import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class ChangeTemporalPasswordGuardService implements CanActivate {
  constructor(public _authService: AuthService, public router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this._authService.itIsTemporalPassword()) {
      this._authService.fromUrl = state.url;
      this.router.navigate(['login']);
      return false;
    }
    return true;
  }
}
